@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackBlock {
  overflow: hidden;

  &.blueTurk {
    .case {
      background: linear-gradient(rgba(58, 111, 243, 0.05) 0%, rgb(58 111 243 / 3%) 100%);
    }
  }

  .case {
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: linear-gradient(180deg, rgba(0, 229, 50, 0.00) 0%, rgba(0, 255, 55, 0.06) 100%);
    padding: 40px;

    &.black {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.06) 100%);
    }

    .scoreIcon {
      align-items: center;
      margin-bottom: 50px;
      display: flex;
      justify-content: center;
      height: 150px;
      width: 150px;
      position: relative;
      margin-left: auto;
      margin-right: auto;
      transform: scale(2);

      @include icons.ico("colored-structure");

      &.prestashop {
        @include icons.ico("colored-prestashop");
      }
    }

    .text {
      font-size: 34px;
      width: calc(100% - 30px);
      max-width: 1100px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      z-index: 1;

      @include texts.font("bold");
    }

    .buttons {
      display: flex;
      gap: 15px;
      position: relative;
      align-items: center;
      justify-content: center;
      margin-top: 35px;

      .button {
        position: relative;
        border-radius: 20px;
        border-top: 2px solid var(--web-border-blue);
        background: var(--web-grad-blue);
        font-size: 16px;
        color: var(--white);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 32px;
        height: fit-content;
        cursor: pointer;

        &.black {
          border-top: 1px solid var(--web-grey);
          background: var(--web-black-gradient);

          &:hover {
            background: var(--web-black-gradient-hover);
          }
        }

        &.turk {
          border-top: 1px solid #A5DBE8;
          background: linear-gradient(180deg, #6BCAE1 0%, #007F9E 100%);

          &:hover {
            background: linear-gradient(180deg, #49b3ca 0%, #00576e 100%);
          }
        }

        &:hover {
          background: var(--web-blue-hover);

          .icon {
            transform: translateX(8px);
          }
        }

        .content {
          display: flex;
          gap: 15px;
          position: relative;
          align-items: center;
        }
      }
    }
  }

  @media screen and (max-width: 930px) {
    .case {
      padding: 15px !important;

      .scoreIcon {
        transform: scale(1) !important;
      }

      .text {
        font-size: 22px !important;
        width: 100% !important;
      }

      .button {
        padding: 10px 20px !important;

        .content {
          text-align: center;
        }
      }
    }
  }
}